import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";

export interface DesignerActivityEntry {
  contractor_id: string;
  contractor_name: string;
  /** "contractor" = external company; "employee" = internal employee signer. */
  kind: "contractor" | "employee";
  cluster_count: number;
  total_revisions: number;
  pending_count: number;
  signed_count: number;
  rejected_count: number;
  avg_turnaround_hours: number | null;
  last_activity_at: string | null;
}

interface DesignerActivityFilters {
  date_from?: string;
  date_to?: string;
}

export function useDesignerActivity(filters: DesignerActivityFilters) {
  const params: Record<string, string> = {};
  if (filters.date_from) params.date_from = filters.date_from;
  if (filters.date_to) params.date_to = filters.date_to;

  return useQuery({
    queryKey: ["designer-activity", filters],
    queryFn: () =>
      apiClient
        .get<{
          data: { results: DesignerActivityEntry[] };
          meta: { count: number };
        }>("/project-docs/designer-activity/", { params })
        .then((r) => r.data),
    staleTime: 30_000,
  });
}
